'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createDispatch;

var _utils = require('../utils');

function createDispatch(originDispatch) {
  return function dispatch(actionType, payload, meta) {
    // 这边是为了兼容社区方案，允许直接传入一个 action 对象，比如路由跳转：
    // send(push('/a/b'))

    if (_utils.is.obj(actionType) && _utils.is.str(actionType.type)) {
      var externalAction = actionType;
      return originDispatch(externalAction);
    }

    var action = {
      type: actionType
    };

    action.payload = payload;
    action.meta = meta;

    return originDispatch(action);
  };
}
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL21vZHVsZXMvY29yZS9jcmVhdGVEaXNwYXRjaC5qcyJdLCJuYW1lcyI6WyJjcmVhdGVEaXNwYXRjaCIsIm9yaWdpbkRpc3BhdGNoIiwiZGlzcGF0Y2giLCJhY3Rpb25UeXBlIiwicGF5bG9hZCIsIm1ldGEiLCJpcyIsIm9iaiIsInN0ciIsInR5cGUiLCJleHRlcm5hbEFjdGlvbiIsImFjdGlvbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7a0JBRXdCQSxjOztBQUZ4Qjs7QUFFZSxTQUFTQSxjQUFULENBQXlCQyxjQUF6QixFQUF5QztBQUN0RCxTQUFPLFNBQVNDLFFBQVQsQ0FBbUJDLFVBQW5CLEVBQStCQyxPQUEvQixFQUF3Q0MsSUFBeEMsRUFBOEM7QUFDbkQ7QUFDQTs7QUFFQSxRQUFJQyxVQUFHQyxHQUFILENBQU9KLFVBQVAsS0FBc0JHLFVBQUdFLEdBQUgsQ0FBT0wsV0FBV00sSUFBbEIsQ0FBMUIsRUFBbUQ7QUFDakQsVUFBTUMsaUJBQWlCUCxVQUF2QjtBQUNBLGFBQU9GLGVBQWVTLGNBQWYsQ0FBUDtBQUNEOztBQUVELFFBQU1DLFNBQVM7QUFDYkYsWUFBTU47QUFETyxLQUFmOztBQUlBUSxXQUFPUCxPQUFQLEdBQWlCQSxPQUFqQjtBQUNBTyxXQUFPTixJQUFQLEdBQWNBLElBQWQ7O0FBRUEsV0FBT0osZUFBZVUsTUFBZixDQUFQO0FBQ0QsR0FqQkQ7QUFrQkQiLCJmaWxlIjoiY3JlYXRlRGlzcGF0Y2guanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBpcyB9IGZyb20gJy4uL3V0aWxzJ1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBjcmVhdGVEaXNwYXRjaCAob3JpZ2luRGlzcGF0Y2gpIHtcbiAgcmV0dXJuIGZ1bmN0aW9uIGRpc3BhdGNoIChhY3Rpb25UeXBlLCBwYXlsb2FkLCBtZXRhKSB7XG4gICAgLy8g6L+Z6L655piv5Li65LqG5YW85a6556S+5Yy65pa55qGI77yM5YWB6K6455u05o6l5Lyg5YWl5LiA5LiqIGFjdGlvbiDlr7nosaHvvIzmr5TlpoLot6/nlLHot7PovazvvJpcbiAgICAvLyBzZW5kKHB1c2goJy9hL2InKSlcblxuICAgIGlmIChpcy5vYmooYWN0aW9uVHlwZSkgJiYgaXMuc3RyKGFjdGlvblR5cGUudHlwZSkpIHtcbiAgICAgIGNvbnN0IGV4dGVybmFsQWN0aW9uID0gYWN0aW9uVHlwZVxuICAgICAgcmV0dXJuIG9yaWdpbkRpc3BhdGNoKGV4dGVybmFsQWN0aW9uKVxuICAgIH1cblxuICAgIGNvbnN0IGFjdGlvbiA9IHtcbiAgICAgIHR5cGU6IGFjdGlvblR5cGVcbiAgICB9XG5cbiAgICBhY3Rpb24ucGF5bG9hZCA9IHBheWxvYWRcbiAgICBhY3Rpb24ubWV0YSA9IG1ldGFcblxuICAgIHJldHVybiBvcmlnaW5EaXNwYXRjaChhY3Rpb24pXG4gIH1cbn1cbiJdfQ==